import { gql } from '@apollo/client';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

const AssetFragment = gql`
fragment Asset on CanHaveLabels {
  id
  luid
  name
  __typename
  ... on Column {
    id
    remoteType
    table {
      id
      name
      __typename
    }
  }
  ... on Flow {
    vizportalUrlId
  }
  ... on PublishedDatasource {
    vizportalUrlId
  }
  ... on VirtualConnectionTable {
    vizportalUrlId
  }
  ... on VirtualConnection {
    vizportalUrlId
  }
}
`;

export const LabelAssetFragmentGql = gql`
fragment LabelAsset on Label {
  asset{
    id
    luid
    name
    __typename
    ... on Column {
      id
      remoteType
      table {
        id
        name
        __typename
      }
    }
    ... on Flow {
      vizportalUrlId
    }
    ... on PublishedDatasource {
      vizportalUrlId
    }
    ... on VirtualConnectionTable {
      vizportalUrlId
    }
    ... on VirtualConnection {
      vizportalUrlId
    }
  }
}
`;

export const LabelFragment = gql`
fragment Label on Label {
  id
  authorDisplayName
  author {
    ...TableauUser
  }
  isActive
  value
  isElevated
  message
  category
  updatedAt
  asset {
    ...Asset
  }
  __typename
}
${TableauUserFragmentGql}
${AssetFragment}
`;
